import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { LeftOutlined, LockOutlined, LoginOutlined, UnlockOutlined, UserOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {Layout, Input, Button, Row, Col } from 'antd';
import Headroom from 'react-headroom';
import { FormattedMessage } from 'react-intl';
import { GlobalConfigContext } from '../../components/Config/GlobalConfigContext';
import * as authActions from '../../actions/auth'
//import api from '../../middleware/api';
import logo from '../../native_laboratoire_logo.svg';
import logowapp from '../../wapp.svg';
import "./login.css";
import "../../stylesheets/App.forms.scss";
// import logoFull from '../../wapp.svg';
import Notifications from "../../components/Notifications";
import api from "../../middleware/api";
const {  Header,  Footer  } = Layout;
const FormItem = Form.Item;

class NormalLoginForm extends React.PureComponent {
	static contextType = GlobalConfigContext;
	constructor(props) {
		super(props);
		this.state = {
			isAuthenticating: false,
			forgotPasswordMode: false
		}
    }
    componentDidUpdate = (prevProps) => {
        if(prevProps.isAuthenticating && !this.props.isAuthenticating){
            
        }
    }
	handleSubmit = (e) => {
	    e.preventDefault();
	    this.props.form.validateFields((err, values) => {
			if (!err) {
				//this.setState({ isAuthenticating: true });
                //console.log('Received values of form: ', values);
                const { dispatch } = this.props;
				const login = dispatch(authActions.login({ email: values.email.trim(), password: values.password }));
                login.then(() => {
                    //this.setState({ isAuthenticating: false });
                    if(this.props.loginError){
                        this.context.notifications.notify({
                            title: this.context.intl.formatMessage({ id: 'login.actions.notification.error.title', defaultMessage: 'Login failed!' }),
                            message: this.props.loginError,
                            type: 'notification',
                            kind: 'error'
                        });
                    }
                });
                
				/*api.post(`/users/login`, { email: values.email, password: values.password })
					.then(response => {
						//console.log(response);
						this.setState({ isAuthenticating: false });
						this.context.handleLoggedin(response.data);
						//form.resetFields();
						//this.setState({ error: undefined, isFetching: false, visible: false });
						//this.props.onCreate(response.data.data);
						//this.props.history.push('/');
				}).catch((error) => {
					//console.log('error', error);
					this.setState({ isAuthenticating: false });
					//this.setState({ error: error.message, isFetching: false });	
				});*/
			}
	    });
	}
	signUp() {
    	// create user with isSetup = true
    	// Link to=(setup component link)
	}
	onForgotPassword = () => {
		this.setState({
			forgotPasswordMode: true
		});
	}
	handleForgot = (e) => {
        e.preventDefault();
		/*
		 * authenticate email
		 * create access token
		 * send email with access token
		 * add "please check your email" message
		 */
        //e.preventDefault();
	    this.props.form.validateFields((err, values) => {
	        //console.log(`values:`, values)
			if (err) {

            }
            this.setState({ isAuthenticating: true });
			api.post('users/reset', { email: values.email.trim() }).then(response => {
                //console.log(response);
                this.setState({ isAuthenticating: false });
                this.context.notifications.notify({
                    title: this.context.intl.formatMessage({ id: 'reset.actions.notification.success.title', defaultMessage: 'Account Password Reset succedeed!' }),
                    message: 'Please check your email, and follow the reset password procedure.',
                    type: 'notification',
                    kind: 'success'
                });	
            }).catch((error) => {
                //console.log('error', error);
                this.setState({ isAuthenticating: false });
                this.context.notifications.notify({
                    title: this.context.intl.formatMessage({ id: 'reset.actions.notification.error.title', defaultMessage: 'Reset failed!' }),
                    message: 'This email is not associated with a valid user account',
                    type: 'notification',
                    kind: 'error'
                });	
            });
        });
	}
	onCancelForgot = () => {
		this.setState({
			forgotPasswordMode: false
		});
	}

  	render() {
        const { isAuthenticating } = this.props;
		const { getFieldDecorator } = this.props.form;
		
        return (
			<span>
			<Headroom>								
                <Header id="header">
                <div className='main-layout-container'>
                    <span className="header-logo login">
                        <div className="logo">
                            <img src={logo} alt="Logo" />
                        </div>	
                    	</span>
                    </div>
                </Header>
            </Headroom>
           	 <Row type="flex" align="middle" justify="center" className="login-wrapper">
                <Col xs={24} md={12} lg={16} xl={12} className="bg-pic">
                    {/* <img src={'/assets/login_screen.jpg'} alt="Logo" />*/}
                    <div className="bg-caption">
                        <h1><FormattedMessage id="login.baportal" defaultMessage="<span>Beauty</span><span>Advisors</span><span>Portal</span>" values={{ span: (chunks) => <span>{chunks}</span> }} /></h1>
                    </div> 
                </Col>
                <Col xs={24} md={12} lg={8} xl={12} className="login-container">
                    <Notifications />
                    <Form layout="vertical" onSubmit={this.state.forgotPasswordMode ? this.handleForgot : this.handleSubmit} className="login_form">
{/*                     
                    <div className="logo">
                        <img src={logoFull} alt="Logo" />
                    </div> */}
                    
                    {this.state.forgotPasswordMode?
							<><p><FormattedMessage id="login.hotelizer.password-reset" defaultMessage={`Ξεχάσατε τον κωδικό σας; Μην αγχώνεστε. Απλά πληκτρολογήστε το email με το οποίο κάνατε εγγραφή.`} /></p>
						
								<FormItem label={<FormattedMessage id="login.form.email" defaultMessage={`Email`} />} >
									{getFieldDecorator('email', {
									rules: [{ required: true, message: this.context.intl.formatMessage({id: 'login.form.email.message', defaultMessage: 'Please input your email!'}) }],
									})(
									<Input prefix={<UserOutlined style={{ fontSize: 14 }} />} />
									)}
								</FormItem>
							
								<Button type="link" onClick={this.onCancelForgot} className="login-form-button" loading={isAuthenticating} icon={<LeftOutlined />}>
									<FormattedMessage id="login.forgot-password.back" defaultMessage={`Back`} />
								</Button>
								<Button type="primary" onClick={this.handleForgot} className="login-form-button" loading={isAuthenticating} icon={<UnlockOutlined />}>
									<FormattedMessage id="login.forgot-password.send" defaultMessage={`Reset password`} />
								</Button>
								
							</>:
							<><p><FormattedMessage id="login.hotelizer.sign-in" defaultMessage={`Συνδεθείτε στον λογαρɩασμό σας`} /></p>

								<FormItem className="login-form-input"  label={<FormattedMessage id="login.form.email" defaultMessage={`ΟΝΟΜΑ ΧΡΗΣΤΗ`} />} >
									{getFieldDecorator('email', {										
										rules: [{ required: true, message: this.context.intl.formatMessage({ id: 'login.form.email.message', defaultMessage: 'Please input your email!' }) }],
									})(
										<Input prefix={<UserOutlined style={{ fontSize: 14 }} />} />
									)}
								</FormItem>

								<FormItem label={<FormattedMessage id="login.form.password" defaultMessage={`ΚΩΔΙΚΟΣ`} />}>
									{getFieldDecorator('password', {
										rules: [{ className:"login-form-input", required: true, message: this.context.intl.formatMessage({ id: 'login.form.password.message', defaultMessage: 'Please input your password!' }) }],
									})(
										<Input prefix={<LockOutlined style={{ fontSize: 14 }} />} type="password" />
									)}
								</FormItem>

								<Button type="primary" htmlType="submit" className="login-form-button" loading={isAuthenticating} icon={<LoginOutlined />}>
									<FormattedMessage id="login.sign-in" defaultMessage={`ΕΙΣΟΔΟΣ`} />
								</Button>
								<br />
								<Button type="link" onClick={this.onForgotPassword} className="login-form-button-forgot" icon={<UnlockOutlined />}>
									<FormattedMessage id="login.forgot" defaultMessage={`Ξεχάσατε τον κωδικό σας?`} />
								</Button>
							</>}
                    </Form>

                </Col>
                
            </Row>
			<Footer className="login-footer">
                <div className='main-layout-container footer-flex'>
                    <p>Native Laboratoire Beauty Advisors Portal @ {new Date().getFullYear()}. All rights reserved.</p>
                    <span className="footer-logo">
                        <Link to={`/`} onClick={this.closeDrawer}><img src={logowapp} alt="Wapp Development" /></Link>
                    </span>
                </div>
            </Footer>
			</span>
        );
    }
}

NormalLoginForm.propTypes = {
	dispatch: PropTypes.func.isRequired,
	form: PropTypes.object.isRequired,
	//isAuthenticating: PropTypes.bool
}

function mapStateToProps(state) {
	const { auth } = state;
	if (auth) {
	    return { user: auth.user, loginError: auth.errorMessage, isAuthenticating: auth.isAuthenticating };
	}

	return { user: null };
}

const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

const mapDispatchToProps = dispatch => ({
	authActions: bindActionCreators(authActions, dispatch),
	dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(WrappedNormalLoginForm);
  